export default {
  learnMore: {
    id: 'payment_advertisement_learn_more',
    defaultMessage: 'Learn more',
  },
}
